
import React from "react";
import { Schemes } from "../../utils";
import { Button } from "@ronuse/noseur";
import { i18nManager } from "../../i18n";
import * as ReactRouterDom from "react-router-dom";

function Contact() {
    const labels = i18nManager.Labels.contact;
    const { platform } = ReactRouterDom.useParams();

    return (<div className="contact">
        <hr />
        <span className="title">{labels.dont_find_answer}</span>
        <span className="desc">{labels.get_in_touch}</span>
        <Button link={`/${platform}/contact-us`} text={labels.contact_us} scheme={Schemes.RIVTN_HERA} raised/>
    </div>);
}

export default Contact;
